<template>
    <div
        v-loading.fullscreen.lock="loading"
        element-loading-text="正在上传..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.5)"
    >
        <!-- <div ref="editor" style="text-align:left;"></div> -->
        <!-- <button v-on:click="getContent">查看内容</button> -->
        <!--非全屏模式-->
        <div id="container">
            <!--菜单栏-->
            <div id="toolbar-container">
                <div id="editor-toolbar" ref="editorToolbar"></div>
                <div id="btn-container" title="全屏">
                    <i id="btn1" class="el-icon-full-screen"></i>
                </div>
            </div>
            <!--编辑区域-->
            <div id="editor-text" ref="editorText">
                <!-- <p>wangEditor 本身不包含“全屏”功能，不过可以很简单的开发出来</p>
                <p>注意，全屏模式与<code>max-height</code>有冲突，尽量避免一起使用</p> -->
            </div>
        </div>

        <!--全屏模式-->
        <div id="cover"></div>
    </div>
</template>

<script>
    import E from 'wangeditor'
    import { api } from '@/common/request_course.js'
    import { buildThumborUrl } from '@/common/tool.js'
    export default {
      name: 'editor',
      model: {
        prop: 'value',
        event: 'change'
      },
      props: {
        dataLoaded: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            default: ''
        }  
      },
      data () {
        return {
          editorContent: '',
          editor: null,
          isFullScreen: false,
          loading: false
        }
      },
      watch: {
        dataLoaded: function(val) {
            if (val) {
                this.editor.txt.html(this.value)
            }
            
        }
      },
      methods: {
        getContent: function () {
            console.log(this.editorContent)
        }
      },
      mounted() {
        this.editor = new E(this.$refs.editorToolbar, this.$refs.editorText)

        this.editor.customConfig.menus = [
            'head',  // 标题
            'bold',  // 粗体
            'fontSize',  // 字号
            'fontName',  // 字体
            'italic',  // 斜体
            'underline',  // 下划线
            'strikeThrough',  // 删除线
            'foreColor',  // 文字颜色
            'backColor',  // 背景颜色
            'link',  // 插入链接
            'list',  // 列表
            'justify',  // 对齐方式
            'quote',  // 引用
            'emoticon',  // 表情
            'image',  // 插入图片
            'table',  // 表格
            // 'video',  // 插入视频
            'code',  // 插入代码
            'undo',  // 撤销
            'redo'  // 重复
        ]

        this.editor.customConfig.zIndex = 1000

        // editor.customConfig.uploadImgShowBase64 = true   // 使用 base64 保存图片

        this.editor.customConfig.uploadImgServer =  api.baseUrl + '/minio-oss/fileUpload' //  上传服务器  base64 和上传服务器 二者留其一
        
        // 将图片大小限制为 5M， 这里注释，在下面的uploadImgHooks -> before方法中自定义
        // this.editor.customConfig.uploadImgMaxSize = 5 * 1024 * 1024

        this.editor.customConfig.uploadImgAccept = ['jpg', 'jpeg', 'png']

        this.editor.customConfig.uploadImgParams = {
            // 如果版本 <=v3.1.0 ，属性值会自动进行 encode ，此处无需 encode
            // 如果版本 >=v3.1.1 ，属性值不会自动 encode ，如有需要自己手动 encode
            bucketName: 'fzzht-member-image',
        }
        this.editor.customConfig.uploadImgMaxLength = 15
        this.editor.customConfig.uploadFileName = 'files'

        let _this = this;
        this.editor.customConfig.uploadImgHooks = {
            before: function (xhr, editor, files) {
                _this.loading = true;
                // 图片上传之前触发
                // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
                
                // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
                // return {
                //     prevent: true,
                //     msg: '放弃上传'
                // }
                // const file = files[0];
                // const isRequiredImg = /^image\/[jpg|jpeg|png]/i.test(file.type)
                // const isLt5M = file.size / 1024 / 1024 < 5
                // if (!isRequiredImg) {
                //     return {
                //         prevent: true,
                //         msg: '请上传.jpg或.png格式的图片!'
                //     }
                // }
                // if (!isLt5M) {
                //     return {
                //         prevent: true,
                //         msg: '上传图片大小不能超过 5MB!'
                //     }
                // }
                const isRequiredImg = file => /^image\/[jpg|jpeg|png]/i.test(file.type)
                const isRequiredSize = file => file.size / 1024 / 1024 < 5
                if (files.some(file => !isRequiredImg(file))) {
                    return {
                        prevent: true,
                        msg: '请上传.jpg或.png格式的图片!'
                    }
                }
                if (files.some(file => !isRequiredSize(file))) {
                    return {
                        prevent: true,
                        msg: '单个图片大小不能超过 5MB!'
                    }
                }
            },
            success: function (xhr, editor, result) {
                _this.loading = false
                // 图片上传并返回结果，图片插入成功之后触发
                // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
            },
            fail: function (xhr, editor, result) {
                _this.loading = false
                // 图片上传并返回结果，但图片插入错误时触发
                // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
            },
            error: function (xhr, editor) {
                _this.loading = false
                // 图片上传出错时触发
                // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
            },
            timeout: function (xhr, editor) {
                _this.loading = false
                // 图片上传超时时触发
                // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
            },

            // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
            // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
            customInsert: function (insertImg, result, editor) {
                // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
                // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

                // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
                // console.log(result)
                var data = result.data;
                data.forEach(ele => {
                    var url = buildThumborUrl(ele)
                    console.log(url)
                    // var testUrl = 'http://img2.tbcdn.cn/tfscom/i2/2202206711/TB2a7XVbrXlpuFjy1zbXXb_qpXa_%21%212202206711.jpg'
                    insertImg(url)
                });
                
                

                // result 必须是一个 JSON 格式字符串！！！否则报错
            }
        }
        

        this.editor.customConfig.onchange = (html) => {
            this.editorContent = html
            this.$emit('change', this.editorContent)
            this.$emit('input', this.editorContent)
        }
        this.editor.create()
        console.log(this.value)
        this.editor.txt.html(this.value)

        // 获取使用到的元素
        var toolbarContaner = document.getElementById('toolbar-container')
        var editorText = document.getElementById('editor-text')
        var cover = document.getElementById('cover')
        var container = document.getElementById('container')

        // 全屏事件
        function doFullScreen() {
            var h = window.innerHeight
                    || document.documentElement.clientHeight
                    || document.body.clientHeight;
            cover.style.display = 'block'
            editorText.style.height = (h-30) +'px';
            cover.appendChild(toolbarContaner)
            cover.appendChild(editorText)
        }

        // 退出全屏事件
        function unDoFullScreen() {
            container.appendChild(toolbarContaner)
            container.appendChild(editorText)
            editorText.style.height = '300px';
            cover.style.display = 'none'
        }

        // 是否是全屏的标志
        var isFullScreen = false

        // 点击事件
        var fullBtn = document.getElementById('btn-container')
        fullBtn.addEventListener('click', function () {
            if (isFullScreen) {
                isFullScreen = false
                unDoFullScreen()
            } else {
                isFullScreen = true
                doFullScreen()
            }
        }, false)
      }
    }
</script>

<style scoped>
#toolbar-container {
    position: relative;
    border: 1px solid #ccc;
    background-color: #fff;
}
#toolbar-container:after {
    display: table;
    content: '';
    clear: both;
}
#editor-toolbar {
    float: left;
}
#btn-container {
    position: absolute;
    right: 4px;
    top: 0;   
    width: 28px;
    height: 28px;
    cursor: pointer;
    text-align: center;
    line-height: 30px;
}
#btn-container #btn1 {
    font-size: 18px; 
}
#editor-text {
    border: 1px solid #ccc;
    border-top: 0;
    height: 300px;
    background-color: #fff;
}
#cover {
    display: none;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    right: 0;
    bottom: 2px;
    height: 100%;
    background-color: #f1f1f1;
}
</style>


// WEBPACK FOOTER //
// src/components/Editor2.vue